export default "### 2021-07-07 - Portal v4.0.12 Galileo  \n---\n\nBugs Fixed  \n-   Fixed compute group access controls\n"